import React from 'react'
import Loader from "react-loader-spinner";
import { LoadContainer } from "../Vacante/styled.component";

export const LoaderContainer = () => {

  return (
    <LoadContainer >
      <Loader
        type="Circles"
        color="#F5A796"
        height="200"
        width="250"
      />
    </LoadContainer>
  )
}
